import { type ActionEvent, Controller } from "@hotwired/stimulus"

import ModalController from "../modal_controller"
import { ITEM_LIST_NAME } from "./packages_controller_new"

import * as Ga4 from "@/helpers/ga4_helper"

export default class extends Controller {
  static outlets = ["booking-modal", "package-details-modal", "package-voucher-modal"]
  declare readonly bookingModalOutlet: ModalController
  declare readonly packageDetailsModalOutlet: ModalController
  declare readonly packageVoucherModalOutlet: ModalController

  static targets = ["bookButton", "voucherButton"]
  declare readonly bookButtonTarget: HTMLButtonElement
  declare readonly hasBookButtonTarget: boolean
  declare readonly voucherButtonTarget: HTMLButtonElement
  declare readonly hasVoucherButtonTarget: boolean

  static values = { ecommerceItems: Array }
  declare readonly ecommerceItemsValue: Ga4.EcommerceItem[]

  bookButtonClick(): void {
    if (this.hasBookButtonTarget) {
      this.bookButtonTarget.click()
    }
  }

  bookPackage({ params: { ecommerceItem, index } }: ActionEvent): void {
    this.bookingModalOutlet.open()
    Ga4.selectItemEvent({
      ...ecommerceItem,
      index,
      item_list_name: ITEM_LIST_NAME
    })
  }

  buyPackageVoucher({ params: { ecommerceItem, index } }: ActionEvent): void {
    this.packageVoucherModalOutlet.open()
    Ga4.selectItemEvent({
      ...ecommerceItem,
      index,
      item_category: "Package Voucher",
      item_list_name: ITEM_LIST_NAME
    })
  }

  viewPackageDetails({ params: { ecommerceItem, index } }: ActionEvent): void {
    this.packageDetailsModalOutlet.open()
    Ga4.viewItemEvent({ ...ecommerceItem, index, item_list_name: ITEM_LIST_NAME })
  }

  voucherButtonClick(): void {
    if (this.hasVoucherButtonTarget) {
      this.voucherButtonTarget.click()
    }
  }
}
